module.exports = __webpack_public_path__ + "static/img/_G9A0784.4ad3ee3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/_G9A0784.jpg
// module id = EeMn
// module chunks = 0